import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import ModalVideo from 'react-modal-video';
import {FaTwitter ,FaInstagram ,FaFacebookF , FaLinkedinIn} from "react-icons/fa";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";

const SocialShare = [
    {Social: <FaFacebookF /> , link: 'https://www.facebook.com/'},
    {Social: <FaLinkedinIn /> , link: 'https://www.linkedin.com/'},
    {Social: <FaInstagram /> , link: 'https://www.instagram.com/'},
    {Social: <FaTwitter /> , link: 'https://twitter.com/'},
]

class ZerobolasDetails extends Component{
    constructor () {
        super()
        this.state = {
          isOpen: false
        }
        this.openModal = this.openModal.bind(this)
    }
    openModal () {
        this.setState({isOpen: true})
    }
    render(){
        return(
            <React.Fragment>
                <PageHelmet pageTitle='Go2Market' />

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />
                
                {/* Start Breadcrump Area */}
                <div className="rn-page-title-area pt--120 pb--190 bg_image bg_image--4"  data-black-overlay="7">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h2 className="title theme-gradient">ZEROBOLAS</h2>
                                    <p>Aplicación de mercado de segunda mano e inmuebles en América</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Breadcrump Area */}

                {/* Start Portfolio Details */}
                <div className="rn-portfolio-details ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="portfolio-details">
                                    <div className="inner">
                                        <h2>Zerobolas</h2>
                                        <p className="subtitle">Aplicación móvil para el mercado de segunda mano e inmuebles en América.</p>
                                        <p>La aplicación permite a los usuarios poner a la venta sus productos o inmuebles a la aplicación tanto en norteamerica, como latinoamérica.</p>
                                        <p>La aplicación cuenta con sistemas de ubicación (busqueda por radio, puntos en el mapa, etc), sistema de chat para contactar con los interesados, notificaciones push, etc.</p>
                                        <p>Proyecto solicitado por Zerobolas para salir al público a finales de 2023.</p>

                                        <div className="portfolio-view-list d-flex flex-wrap">
                                            <div className="port-view">
                                                <span>Framework Frontend</span>
                                                <h4>Flutter (Móvil)</h4>
                                            </div>

                                            <div className="port-view">
                                                <span>Framework Backend</span>
                                                <h4>Node.js</h4>
                                            </div>

                                            <div className="port-view">
                                                <span>Lenguajes</span>
                                                <h4>Dart & Javascript</h4>
                                            </div>
                                        </div>

                                        <div className="portfolio-share-link mt--20 pb--70 pb_sm--40">
                                            <div className="header-btn">
                                                <a className="rn-btn" >
                                                    <span>Ver app en Play Store (No disponible)</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Portfolio Details */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer />  


            </React.Fragment>
        )
    }
}
export default ZerobolasDetails;
